import { render, staticRenderFns } from "./PopoverLoggedinPerson.vue?vue&type=template&id=3a8cb734&scoped=true"
import script from "./PopoverLoggedinPerson.vue?vue&type=script&lang=js"
export * from "./PopoverLoggedinPerson.vue?vue&type=script&lang=js"
import style0 from "./PopoverLoggedinPerson.vue?vue&type=style&index=0&id=3a8cb734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8cb734",
  null
  
)

export default component.exports